module.exports = __webpack_public_path__ + "static/media/playlist.7763b30b.svg";